import sortBy from 'lodash/sortBy'
import {countries, byIso} from 'country-code-lookup'

type Country = {
  country: string
  iso3: string
}

export const sortedCountries: Array<Country> = sortBy(countries, c =>
  // Put USA first
  c.iso3 === 'USA' ? 'A' : c.country
)

export function getCountryByIso3(iso3: string): Country | undefined | null {
  return byIso(iso3)
}
